export const QzTrayCertificate =
  '-----BEGIN CERTIFICATE-----\n' +
  'MIIFPDCCAySgAwIBAgIQNzkyMDI0MDcwMTA5MDczNjANBgkqhkiG9w0BAQsFADCB\n' +
  'mDELMAkGA1UEBhMCVVMxCzAJBgNVBAgMAk5ZMRswGQYDVQQKDBJRWiBJbmR1c3Ry\n' +
  'aWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcGA1UEAwwQ\n' +
  'cXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBxemluZHVz\n' +
  'dHJpZXMuY29tMB4XDTI0MDcwMTA5MDczNloXDTI1MDcxODE3NDM0NlowgfUxCzAJ\n' +
  'BgNVBAYMAkdCMRQwEgYDVQQIDAtTbGFpdGh3YWl0ZTEVMBMGA1UEBwwMSHVkZGVy\n' +
  'c2ZpZWxkMRkwFwYDVQQKDBBUTVMgU29mdHdhcmUgTHRkMRkwFwYDVQQLDBBUTVMg\n' +
  'U29mdHdhcmUgTHRkMRkwFwYDVQQDDBBUTVMgU29mdHdhcmUgTHRkMSowKAYJKoZI\n' +
  'hvcNAQkBDBtzbWFndWlyZUB0bXMtc29mdHdhcmUuY28udWsxPDA6BgNVBA0MM3Jl\n' +
  'bmV3YWwtb2YtYmZmZjUxOWI2MjVjMDM5ZTU1Mzg4Y2ExMTE4ZmQxNDhjZGNiMTFm\n' +
  'MzCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAI1qLICyQCNRL83+09yn\n' +
  'uUOtJ8te0sgH7S+lUjKuUx96fdYC/L4tvgpFmGrvVgwp2QYVYydhtLEPud5WlkPW\n' +
  'hAcH6yKyrz/848p901VpbNnSuqkhNv58za7LFHNh18T2IlbvTLqOJiaoKezK23i9\n' +
  '08ro5T3pFjai4iVP/Z9UEFkqsqHpRGm2oH/9WnjPKrIjcCb9LxsN6ZlzgR0Srxkg\n' +
  'A6hByCtfEW/A3YBvb2P0pduNqBV3//as2Ha/qSy2IFY1N5yNGyHGh4KgWxgVyJKY\n' +
  'TNUTctEo/bEpK/p33QczwmVekFDObwEknABMzi9Q00+iHRLCGWNm7PsByTzjdNmK\n' +
  'TRECAwEAAaMjMCEwHwYDVR0jBBgwFoAUkKZQt4TUuepf8gWEE3hF6Kl1VFwwDQYJ\n' +
  'KoZIhvcNAQELBQADggIBAINWs4TwMoioX5Q3h6f4EuD87Ccnwl4xbtvNvUQWgRII\n' +
  'GGsvQRyaD7RV+tCakkaXgQoMKHtlSjVnYLlM63L8VB6kcy8PxKlcycA0Xd9sJpn3\n' +
  'CDnT9ZKIPEmqfw2wTKVMYmw0h3fTipdMVv8YClRLqR385dqrjQaSCSmeEMoswgFx\n' +
  'l1agtrsBUoCNevLA1RopOgNSLL489kZgMl9bBsf/e15JrFKB9L/8WNQteXh05KHi\n' +
  'hDKpH90xL9ubJBmVSN45tBIzVqcQyjXTvlKXbdy8MX69i0/E3Qpz8DccFQn3TS32\n' +
  'pJUIHPZNDkgu0h8q2S5rFbXMjSCWGdgg+4qirFH3KiS2ETWpPT1iFIsnlJAnIci3\n' +
  'BKQcJpeuxms/mwtf9VMEJ40c/JH2wIHwW0imMxYvIvIIpO/Vo2yEu1j4T4S+Dau9\n' +
  'zL/o9H+R9QoWTwEtsI1i0HcpyeCHlv0b4Ys0uR+5TrtLA1LJn4fI+wzKxJinDyZT\n' +
  'GMn6N41TZTRaIkXjiJ1JuEuThnyv/rU02MZmccUg3Mp8eT00cmQBYNCqahwxgFaX\n' +
  'fH7RmVqPR8XrRKwVMA3+M30NpFyuK1/seN6Pyv0ty7+0lAG6xa33DRxR1WcJkdQZ\n' +
  'k+6jR/EMzq+B2fTSDlsvOZ2A9MU/S/h+D/+28cTcsNsMeHE8ReTqgmuyVbcwkK7S\n' +
  '-----END CERTIFICATE-----\n' +
  '--START INTERMEDIATE CERT--\n' +
  '-----BEGIN CERTIFICATE-----\n' +
  'MIIFEjCCA/qgAwIBAgICEAAwDQYJKoZIhvcNAQELBQAwgawxCzAJBgNVBAYTAlVT\n' +
  'MQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYDVQQKDBJRWiBJ\n' +
  'bmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMsIExMQzEZMBcG\n' +
  'A1UEAwwQcXppbmR1c3RyaWVzLmNvbTEnMCUGCSqGSIb3DQEJARYYc3VwcG9ydEBx\n' +
  'emluZHVzdHJpZXMuY29tMB4XDTE1MDMwMjAwNTAxOFoXDTM1MDMwMjAwNTAxOFow\n' +
  'gZgxCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJOWTEbMBkGA1UECgwSUVogSW5kdXN0\n' +
  'cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMxGTAXBgNVBAMM\n' +
  'EHF6aW5kdXN0cmllcy5jb20xJzAlBgkqhkiG9w0BCQEWGHN1cHBvcnRAcXppbmR1\n' +
  'c3RyaWVzLmNvbTCCAiIwDQYJKoZIhvcNAQEBBQADggIPADCCAgoCggIBANTDgNLU\n' +
  'iohl/rQoZ2bTMHVEk1mA020LYhgfWjO0+GsLlbg5SvWVFWkv4ZgffuVRXLHrwz1H\n' +
  'YpMyo+Zh8ksJF9ssJWCwQGO5ciM6dmoryyB0VZHGY1blewdMuxieXP7Kr6XD3GRM\n' +
  'GAhEwTxjUzI3ksuRunX4IcnRXKYkg5pjs4nLEhXtIZWDLiXPUsyUAEq1U1qdL1AH\n' +
  'EtdK/L3zLATnhPB6ZiM+HzNG4aAPynSA38fpeeZ4R0tINMpFThwNgGUsxYKsP9kh\n' +
  '0gxGl8YHL6ZzC7BC8FXIB/0Wteng0+XLAVto56Pyxt7BdxtNVuVNNXgkCi9tMqVX\n' +
  'xOk3oIvODDt0UoQUZ/umUuoMuOLekYUpZVk4utCqXXlB4mVfS5/zWB6nVxFX8Io1\n' +
  '9FOiDLTwZVtBmzmeikzb6o1QLp9F2TAvlf8+DIGDOo0DpPQUtOUyLPCh5hBaDGFE\n' +
  'ZhE56qPCBiQIc4T2klWX/80C5NZnd/tJNxjyUyk7bjdDzhzT10CGRAsqxAnsjvMD\n' +
  '2KcMf3oXN4PNgyfpbfq2ipxJ1u777Gpbzyf0xoKwH9FYigmqfRH2N2pEdiYawKrX\n' +
  '6pyXzGM4cvQ5X1Yxf2x/+xdTLdVaLnZgwrdqwFYmDejGAldXlYDl3jbBHVM1v+uY\n' +
  '5ItGTjk+3vLrxmvGy5XFVG+8fF/xaVfo5TW5AgMBAAGjUDBOMB0GA1UdDgQWBBSQ\n' +
  'plC3hNS56l/yBYQTeEXoqXVUXDAfBgNVHSMEGDAWgBQDRcZNwPqOqQvagw9BpW0S\n' +
  'BkOpXjAMBgNVHRMEBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAJIO8SiNr9jpLQ\n' +
  'eUsFUmbueoxyI5L+P5eV92ceVOJ2tAlBA13vzF1NWlpSlrMmQcVUE/K4D01qtr0k\n' +
  'gDs6LUHvj2XXLpyEogitbBgipkQpwCTJVfC9bWYBwEotC7Y8mVjjEV7uXAT71GKT\n' +
  'x8XlB9maf+BTZGgyoulA5pTYJ++7s/xX9gzSWCa+eXGcjguBtYYXaAjjAqFGRAvu\n' +
  'pz1yrDWcA6H94HeErJKUXBakS0Jm/V33JDuVXY+aZ8EQi2kV82aZbNdXll/R6iGw\n' +
  '2ur4rDErnHsiphBgZB71C5FD4cdfSONTsYxmPmyUb5T+KLUouxZ9B0Wh28ucc1Lp\n' +
  'rbO7BnjW\n' +
  '-----END CERTIFICATE-----';

export const QzTrayPrivateKey =
  '-----BEGIN PRIVATE KEY-----\n' +
  'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCNaiyAskAjUS/N\n' +
  '/tPcp7lDrSfLXtLIB+0vpVIyrlMfen3WAvy+Lb4KRZhq71YMKdkGFWMnYbSxD7ne\n' +
  'VpZD1oQHB+sisq8//OPKfdNVaWzZ0rqpITb+fM2uyxRzYdfE9iJW70y6jiYmqCns\n' +
  'ytt4vdPK6OU96RY2ouIlT/2fVBBZKrKh6URptqB//Vp4zyqyI3Am/S8bDemZc4Ed\n' +
  'Eq8ZIAOoQcgrXxFvwN2Ab29j9KXbjagVd//2rNh2v6kstiBWNTecjRshxoeCoFsY\n' +
  'FciSmEzVE3LRKP2xKSv6d90HM8JlXpBQzm8BJJwATM4vUNNPoh0SwhljZuz7Ack8\n' +
  '43TZik0RAgMBAAECggEAFAQieu/gCK+x5MYsPjgGTtg4QP6xtor6rUsI7LAEh3ja\n' +
  'zVs8Y33Nf540sfQg+ZVFyOjnkTgw73vymtAmMkFvjCA4jb99c0DsDCoNqvICbH15\n' +
  'mr1fD5viMBrCEQfZFuGg4C28bk53A3M7he77rCYwT3DyG7Z9hKu+9zmQhEgNjVU6\n' +
  'OSssVl+KzT4AGy7TLXbPpYtjrXgoXIubHrmLOk7nKu81McMf14PNE70u9MAD9vDJ\n' +
  'stiuWgmx0PN98Jbi0b8/PCzFPovE0CwuoFM0kd9p5XAP0wgHAiHp1rdAGqwCMpF8\n' +
  'ZVZmEL6ytXE994AWyGZEJ4LpNInxU0tvKkME3Dr/fQKBgQC+es5aSpLfGArUrweE\n' +
  'XJHpufNRKTc+Nk9+HuGetEzqst/jIzf9A10dmCXdG7vhDsGe99PpfK43M94xC6pL\n' +
  '8+mwy12XRclelRm1JkiubMfie5Oq5+5S3r79SmzARd4D117YZN3i6QoS2zsBzOwQ\n' +
  '1InzgXCX83X932aHOIgj0FBUlQKBgQC+DtKDQE7g4UAG7o/p8JcMZPcfSs9hrQ+j\n' +
  '6TFD8yXAk1ih1wqP2wtRebYdBBBfxGvQRntCScfhe7H4ZjzTCPCZyRs4LbtfJPul\n' +
  'WBaqcfu42PVtmJuKMMd53b/DQJHHc+TFRtgXfcknAvlusswFbOo2FtUlXC1nULzv\n' +
  'RlR7muAbjQKBgCZe8sa5kxCh9TyW7bq6MyKUNPG6jchYhHbxnZ2s0HnPAs7sv1CW\n' +
  'puFZTvdVqOlTYam2XtgAJ9AzAKV8phea0Q6uSPI6OrB09LLLPYT1oOZ84mhhRF8p\n' +
  'Q+weW/33lRvM/Ow2lYQqUb8urppUP5G8XvXQs2/IuZIkuLCwsKwWQLhpAoGBAKfG\n' +
  'M+UzVq5DiZ7U52vvO5fwZQpVot4pxJ3AVAIU2WW3bM1pJGS7S7F/zNiuZrnzje0M\n' +
  '2vA4a19ML14E+nqc8LABDKs6C6bA4fgi29dYyYpy060Mw3lo+B5HN2noTQgR8YiI\n' +
  'smeCXZi3knM7GMlNTS+0VjIlvdrvNenPXvLCVEVdAoGAZPdzhi/x4NsL4v7LeO1U\n' +
  'I9LED6/dZcdiXQAMoKqjTKGeuTlUqOSRUGmSt+lX4HcsXlw3tTwz6L0+kxIuXaEn\n' +
  'OR+vP7GdW65Z4Cg6BdCjnEZojNuBeNKwsQxdPSrMRyuvj/BGg1pD9yCYeEbdIIgs\n' +
  'ZPWQLkjFrWF5Tpv233stBxw=\n' +
  '-----END PRIVATE KEY-----';
